import { __assign, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { keyDownAction } from '../../utils/keyDownAction';
import { classNames } from '../../utils/stringUtils';
import styles from '../Button.module.css';
import tokens from '@metro-ui/tokens/css/custom-properties.module.css';
import { Spinner } from '../../Spinner';
var handleOnClick = function (onClick) {
    return function (e) {
        onClick(e);
    };
};
export var ButtonBase = React.forwardRef(function (_a, ref) {
    var _b;
    var size = _a.size, _c = _a.type, type = _c === void 0 ? 'button' : _c, isDisabled = _a.isDisabled, isBeforeValidation = _a.isBeforeValidation, isWaiting = _a.isWaiting, isBeforeValidationCallback = _a.isBeforeValidationCallback, isWaitingCallback = _a.isWaitingCallback, onClick = _a.onClick, Icon = _a.Icon, spinnerSize = _a.spinnerSize, href = _a.href, label = _a.label, _d = _a.className, className = _d === void 0 ? '' : _d, children = _a.children, htmlAttributes = __rest(_a, ["size", "type", "isDisabled", "isBeforeValidation", "isWaiting", "isBeforeValidationCallback", "isWaitingCallback", "onClick", "Icon", "spinnerSize", "href", "label", "className", "children"]);
    React.useEffect(function () {
        isWaitingCallback === null || isWaitingCallback === void 0 ? void 0 : isWaitingCallback(!!isWaiting);
    }, [isWaiting, isWaitingCallback]);
    React.useEffect(function () {
        if (!isBeforeValidationCallback)
            return;
        isBeforeValidationCallback(!!isBeforeValidation);
    }, [isBeforeValidation, isBeforeValidationCallback]);
    var buttonBaseClassNames = classNames((_b = {},
        _b[tokens.mdsComp] = true,
        _b[styles.isWaiting] = !!isWaiting,
        _b[styles.isDisabled] = !!isDisabled,
        _b[styles.isBeforeValidation] = !!isBeforeValidation,
        _b[className] = !!className,
        _b));
    var buttonElement = ref || React.createRef();
    var isLink = href !== undefined;
    var handledOnClick = onClick && !isWaiting ? handleOnClick(onClick) : undefined;
    var linkAttributes = {};
    if (isLink) {
        linkAttributes = {
            tabIndex: 0,
            onKeyDown: handledOnClick && keyDownAction(handledOnClick),
            type: undefined,
            role: 'button',
            href: href,
        };
        if (isDisabled || isWaiting) {
            linkAttributes = __assign(__assign({}, linkAttributes), { tabIndex: -1, onClick: function (e) {
                    e.preventDefault();
                }, onKeyDown: function (e) {
                    e.preventDefault();
                }, disabled: undefined, 'aria-disabled': 'true' });
        }
    }
    var renderChildren = function () {
        var c = children;
        if (isWaiting)
            c = (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.hiddenContent }, children),
                React.createElement(Spinner, { className: styles.centeredSpinner, size: spinnerSize !== null && spinnerSize !== void 0 ? spinnerSize : (size === 'small' ? 'small' : 'medium'), useFontColor: true })));
        return c;
    };
    return React.createElement(isLink ? 'a' : 'button', __assign(__assign(__assign({}, htmlAttributes), { className: buttonBaseClassNames, type: type, ref: buttonElement, onClick: handledOnClick, disabled: isDisabled, 'aria-label': label }), linkAttributes), renderChildren());
});
ButtonBase.propTypes = {
    size: PropTypes.oneOf(['label', 'small', 'medium', 'large', 'x-large']),
    type: PropTypes.oneOf(['button', 'submit', 'reset']),
    isDisabled: PropTypes.bool,
    isBeforeValidation: PropTypes.bool,
    isBeforeValidationCallback: PropTypes.func,
    onClick: PropTypes.func,
    Icon: PropTypes.func,
    href: PropTypes.string,
    label: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
};
//# sourceMappingURL=ButtonBase.js.map